import React from 'react';
import SpirisIcon from '../Icon/SpirisIcon';

interface EmptyStateProps {
    title: string;
    description?: string;
    icon?: string;
    size?: 'sm' | 'md';
    className?: string;
}

const EmptyState = ({ title, description, icon, size = 'md', className = '' }: EmptyStateProps): React.JSX.Element => {
    const classes = ['d-flex flex-column align-items-center justify-content-center text-center', size === 'sm' ? 'p-24' : 'p-48', className].filter(Boolean).join(' ');

    return (
        <div className={classes}>
            {icon !== undefined && <SpirisIcon name={icon} size="xl" className="mb-16" />}
            <h3 className="heading-md">{title}</h3>
            {description !== undefined && <p className="text-secondary mb-0">{description}</p>}
        </div>
    );
};

export default EmptyState;
